// Code from here --- many thanks to authors. https://discourse.threejs.org/t/how-can-i-update-the-target-in-orbit-controls-based-on-camera-position-to-prevent-the-camera-from-tilting/31422

import { MutableRefObject, useEffect, useRef } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import { Vector3 } from "three";
import { CameraControls } from "@react-three/drei";

// Reference to a set of active KeyboardEvent.code entries
const useCodes = () => {
  const codes = useRef(new Set());
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => codes.current.add(e.code);
    const onKeyUp = (e: KeyboardEvent) => codes.current.delete(e.code);
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("keyup", onKeyUp);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("keyup", onKeyUp);
    };
  }, []);
  return codes;
};

export function WasdControls({
  cameraControls,
  movementSpeed,
  panSpeed,
}: {
  cameraControls: MutableRefObject<CameraControls | undefined>;
  movementSpeed: number;
  panSpeed: number;
}) {
  const code = useCodes();

  useFrame((_, delta) => {
    const moveSpeed = code.current.has("ShiftLeft")
      ? movementSpeed * 3
      : movementSpeed;
    if (code.current.has("KeyW")) cameraControls.current?.forward(delta * moveSpeed, false);
    if (code.current.has("KeyA")) cameraControls.current?.truck(-delta * moveSpeed, 0, false);
    if (code.current.has("KeyS")) cameraControls.current?.forward(-delta * moveSpeed, false);
    if (code.current.has("KeyD")) cameraControls.current?.truck(delta * moveSpeed, 0, false);
    if (code.current.has("KeyQ")) cameraControls.current?.elevate(delta * moveSpeed, false);
    if (code.current.has("KeyE")) cameraControls.current?.elevate(-delta * moveSpeed, false);
  });

  return null;
}
